<template>
  <ModalDialog
    ref="dialog"
    title="Approve Price Update Request"
    :submitting="submitting"
    :submitDisabled="currentlyUploading"
    :scrollable="true"
    submitTitle="Approve"
    icon="fa-money-check-edit-alt"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="dialogForm">
      <NotificationBar type="warning" v-if="salesPriceUpdateCount > 0 || priceListUpdateCount > 0">
        <NotificationBarTitle>This will approve the price request</NotificationBarTitle>
          <ul>
            <li>Please note approving the price request update will move it into the processing status.</li>
            <li>This process may take a while, depending on the number of active customers available.</li>
          </ul>
      </NotificationBar>
      
      <FormRowFull v-if="salesPriceUpdateCount > 0">
        <div class="font-weight-bold">{{salesPriceUpdateCount}} sales price{{salesPriceUpdateCount | displayCountPlural}} updated</div>
      </FormRowFull>
      <FormRowFull v-if="supplierPriceUpdateCount > 0">
        <div class="font-weight-bold">{{supplierPriceUpdateCount}} supplier price{{supplierPriceUpdateCount | displayCountPlural}} updated</div>
      </FormRowFull>
      <FormRowFull v-if="isUpdatingPriceLists > 0 && !isSendingPriceLists">
        <div class="font-weight-bold">{{priceListUpdateCount}} customer price list{{priceListUpdateCount | displayCountPlural}} updated</div>
      </FormRowFull>
      <div v-if="isSendingPriceLists">
        <FormRowFull>
          <div class="font-weight-bold">{{contactFlaggedEmailCount}} customer price list{{contactFlaggedEmailCount | displayCountPlural}} to send</div>
        </FormRowFull>

        <EmailMessageForm 
          :ccAvailable="false"
          :attachmentsAvailable="false"
          :templateType="MessageTemplateTypes.customerPriceList"
          :contactListUpdateFn="contactListUpdateFn"
          :messageTemplateUpdateFn="messageTemplateUpdateFn"
          @uploading="currentlyUploading = $event"
          @update="emailDetails = $event"
        />
      </div>

    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import EmailMessageForm from '@/modules/core/components/emailMessageForm'

import { ApprovalTypes, MessageTemplateTypes, CommunicationMethodTypes } from '@/store/types'

export default {
  name: 'ApproveRequestDialog',
  mixins: [
    ModalDialogMixin,
    form
  ],
  components: {
    ModalDialog,
    EmailMessageForm
  },
  props: {
    priceRequestId: Number,
    salesPriceUpdateCount: Number,
    supplierPriceUpdateCount: Number,
    contactFlaggedEmailCount: Number,
    priceListUpdateCount: Number
  },
  data() {
    return {
      responseInfo: {},
      dialogForm: {},
      emailDetails: {},
      submitting: false,
      currentlyUploading: false,

      contactListUpdateFn: this.getContactListUpdatePromise,
      messageTemplateUpdateFn: this.getMessageTemplateUpdatePromise,
    }
  },
  created() {
    this.MessageTemplateTypes = MessageTemplateTypes
  },
  mounted() {
  },
  computed: {
    isUpdatingPriceLists() {
      return this.priceListUpdateCount > 0
    },
    isSendingPriceLists() {
      return this.contactFlaggedEmailCount > 0
    }
  },
  methods: {
    show(stockData) {
      // Reset form
      this.emailData = { }
      this.responseInfo = { }
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var approveData = {
        messageSubject: this.emailDetails.messageSubject,
        messageContent: this.emailDetails.messageContent,
        uploadFileList: this.emailDetails.uploadFileList,
      }
      // Email person list
      // Note: Server will match upcontactId's for the correct customer price lists
      if(this.isSendingPriceLists && this.emailDetails.contactPersonList) {
        approveData.emailPersonList = this.emailDetails.contactPersonList.map(person => {
          return {
           contactId: person.contact.id,
           contactPersonId: person.id
          }
        })
      }

      this.$apiService.pricingService.approvePriceRequest(this.priceRequestId, approveData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.$data.dialogForm = this.processFormResponse(err)
      })
      .finally(() => {
        this.$data.submitting = false
      })
    },
    getContactListUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.pricingService.getPriceRequestApprovalContacts(this.$props.priceRequestId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    },
    getMessageTemplateUpdatePromise(messageTemplateId) {
      return new Promise((resolve, reject) => {
        return this.$apiService.pricingService.getPriceRequestApprovalTemplate(this.$props.priceRequestId, messageTemplateId)
        .then(response => {
          return resolve(response.data)
        })
        .catch(err => { reject(err) })
      })
    }
  }
}
</script>